export const formatPhoneNumber = (phone: string): string => {
  const trimmedPhone = phone.replace(/\s/g, '');
  if (trimmedPhone.length > 6) {
    return `(${trimmedPhone.substring(0, 3)}) ${trimmedPhone.substring(3, 6)} ${trimmedPhone.substring(6, trimmedPhone.length)}`;
  }
  return phone;
};